import { Fragment, useEffect, useState } from "react";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { Link, useParams } from "react-router-dom";
import Footer from "../../components/footer/Footer";
import ContactForm from "../../components/ContactFrom/ContactForm";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import Navbar2 from "../../components/Navbar2/Navbar2";
import img from "../../images/page-title.jpg";
import StarLoader from "../../components/loader/StarLoader";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const ServiceSinglePage = () => {
  const { id } = useParams();
  const [serviceDetails, setServiceDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mainImage, setMainImage] = useState(null);
  const [allServices, setAllServices] = useState([]);
  const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;

  useEffect(() => {
    const fetchService = async () => {
      try {
        const response = await fetch(`${apiUrl}/api/service/${id}`);
        const data = await response.json();
        setServiceDetails(data);
        setMainImage(data.banner);
      } catch (error) {
        console.error("Error fetching service:", error);
      } finally {
        setLoading(false);
      }
    };

    const fetchAllServices = async () => {
      try {
        const response = await fetch(`${apiUrl}/api/service`);
        const data = await response.json();
        setAllServices(data);
      } catch (error) {
        console.error("Error fetching all services:", error);
      }
    };

    fetchService();
    fetchAllServices();
  }, [id]);

  // 👇 Show loader while loading is true, else show the full page
  if (loading) {
    return <StarLoader />;
  }
  if (!serviceDetails)
    return (
      <p style={{ textAlign: "center", padding: "50px" }}>Service not found</p>
    );

  const imagesArray = serviceDetails.images
    ? JSON.parse(serviceDetails.images)
    : [];
  const relatedServices = allServices
    .filter((s) => s.id !== Number(id))
    .slice(0, 3);

  const buttonContainerStyle = {
    textAlign: "center",
  };

  const buttonStyle = {
    background: "linear-gradient(90deg, #001F5C, #007BFF)",
    color: "#fff",
    border: "none",
    padding: "8px 14px",
    borderRadius: "5px",
    cursor: "pointer",
    transition: "background 0.3s ease",
    boxShadow: "0 0 8px rgba(0, 31, 92, 0.5)", // glowing orange shadow for button
  };

  return (
    <Fragment>
      <Navbar2 hclass={"wpo-header-style-1"} />
      <PageTitle
        pageTitle={serviceDetails.serviceName}
        pagesub={"Service"}
        img={img}
      />

      <section
        className="wpo-service-single-area section-padding"
        style={{
          backgroundColor: "#E6F7FF",
          paddingTop: "40px", // reduce vertical padding
          paddingBottom: "40px", // reduce vertical padding
        }}
      >
        <div className="container">
          <div
            className="row align-items-start"
            style={{
              padding: "40px 20px",
              borderRadius: "15px",
              background: "linear-gradient(180deg, #ffffff, #f8fbff)",
              boxShadow: "0 0 25px rgba(0, 0, 139, 0.1)",
              marginBottom: "40px",
            }}
          >
            {/* Left: Service Image Section */}
            <div
              className="col col-lg-5 col-12"
              style={{ marginBottom: "25px" }}
            >
              <div style={{ textAlign: "center" }}>
                <Zoom>
                  <img
                    src={`${apiUrl}/storage/${mainImage}`}
                    alt={serviceDetails.serviceName}
                    style={{
                      width: "100%",
                      height: "360px",
                      objectFit: "cover",
                      borderRadius: "15px",
                      border: "2px solid rgba(0,0,139,0.2)",
                      boxShadow: "0 6px 20px rgba(0,0,139,0.15)",
                      transition: "transform 0.3s ease",
                      boxShadow: "0 10px 25px rgba(0, 0, 50, 0.6)",
                    }}
                  />
                </Zoom>
              </div>

              {/* Thumbnail Gallery */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "15px",
                }}
              >
                {[serviceDetails.banner, ...imagesArray].map((img, index) => (
                  <img
                    key={index}
                    src={`${apiUrl}/storage/${img}`}
                    alt="service-thumb"
                    onClick={() => setMainImage(img)}
                    style={{
                      width: "85px",
                      height: "85px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      border:
                        mainImage === img
                          ? "3px solid darkblue"
                          : "1px solid rgba(0,0,139,0.3)",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      boxShadow: "0 10px 25px rgba(0, 0, 50, 0.6)",
                    }}
                  />
                ))}
              </div>
            </div>

            {/* Right: Service Details */}
            <div className="col col-lg-7 col-12">
              <div className="service-details" style={{ padding: "0 25px" }}>
                <h2
                  style={{
                    background: "linear-gradient(90deg, darkblue, #1E90FF)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    fontSize: "2rem",
                    fontWeight: "700",
                    marginBottom: "15px",
                  }}
                >
                  {serviceDetails.serviceName}
                </h2>

                <p
                  style={{
                    color: "#333",
                    lineHeight: "1.7",
                    fontSize: "1rem",
                    textAlign: "justify",
                    marginBottom: "15px",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: serviceDetails.description,
                  }}
                />

                <ul
                  style={{
                    color: "#444",
                    lineHeight: "1.6",
                    paddingLeft: "20px",
                  }}
                >
                  <li
                    dangerouslySetInnerHTML={{ __html: serviceDetails.details }}
                  />
                </ul>
              </div>
            </div>
          </div>

          {/* Related Services Section */}
          <div
            className="wpo-service-single-item"
            style={{ marginTop: "50px" }}
          >
            <div
              style={{
                marginBottom: "30px",
                padding: "15px 40px",
                borderRadius: "10px",
                color: "#fff",
                boxShadow: "0 0 40px 5px rgba(0, 0, 139, 0.25)", // ✅ dark blue box shadow only
                background: "#fff",
              }}
            >
              <h3 style={{ margin: 0 }}>Related Services</h3>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
                gap: "25px",
              }}
            >
              {relatedServices.map((service) => (
                <div
                  key={service.id}
                  style={{
                    background: "#fff",
                    borderRadius: "12px",
                    boxShadow: "0 4px 15px rgba(0,0,139,0.15)",
                    overflow: "hidden",
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-6px)";
                    e.currentTarget.style.boxShadow =
                      "0 8px 25px rgba(0,0,139,0.35)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 15px rgba(0,0,139,0.15)";
                  }}
                >
                  <div style={{ height: "200px", overflow: "hidden" }}>
                    <img
                      src={`${apiUrl}/storage/${service.banner}`}
                      alt={service.serviceName}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        transition: "transform 0.4s ease",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.transform = "scale(1.08)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.transform = "scale(1)")
                      }
                    />
                  </div>
                  <div style={{ padding: "15px" }}>
                    <h3
                      style={{
                        color: "darkblue",
                        fontWeight: "600",
                        marginBottom: "10px",
                        fontSize: "1.1rem",
                      }}
                    >
                      <a
                        onClick={ClickHandler}
                        href={`/service-single/${service.id}`}
                      >
                        {service.serviceName}
                      </a>
                    </h3>
                    <p
                      style={{
                        color: "#555",
                        fontSize: "0.95rem",
                        lineHeight: "1.5",
                        height: "60px",
                        overflow: "hidden",
                      }}
                      dangerouslySetInnerHTML={{ __html: service.description }}
                    />
                    <div style={buttonContainerStyle}>
                      <Link
                        onClick={ClickHandler}
                        to={`/service-single/${service.id}`}
                      >
                        <button
                          style={buttonStyle}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(90deg, #002B80, #339CFF)";
                            e.currentTarget.style.boxShadow =
                              "0 0 15px rgba(0, 123, 255, 0.6)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(90deg, #001F5C, #007BFF)";
                            e.currentTarget.style.boxShadow =
                              "0 0 8px rgba(0, 31, 92, 0.5)";
                          }}
                          data-bs-toggle="tooltip"
                          data-bs-html="true"
                          title="Add to Cart"
                        >
                          View Details
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Contact Form */}
          <div style={{ marginTop: "60px", textAlign: "center" }}>
            <div style={{ marginBottom: "25px" }}>
              <h2
                style={{
                  background: "linear-gradient(90deg, darkblue, #1E90FF)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontWeight: "700",
                  fontSize: "2rem",
                }}
              >
                Ready to Grow Your Business with Us?
              </h2>
              <p style={{ color: "#4b5563", fontSize: "1.05rem" }}>
                Contact Star Family Industry PLC today to discuss import and
                export solutions tailored to your business needs.
              </p>
            </div>
            <div className="wpo-contact-form-area">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default ServiceSinglePage;
